import React from 'react';
import { Row, Col, Button, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

class TimeInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            didChange: false,
            beginTimestamp: this.props.timeTracking != null && this.props.timeTracking.beginTimestamp != null ?
                new Date(Date.UTC(
                    this.props.date.substr(0, 4),
                    parseInt(this.props.date.substr(5, 2)) - 1,
                    parseInt(this.props.date.substr(8, 2)),
                    parseInt(this.props.timeTracking.beginTimestamp.substr(11, 2)),
                    parseInt(this.props.timeTracking.beginTimestamp.substr(14, 2)),
                    0
                )).toISOString().substr(0, 23) : 0,
            endTimestamp: this.props.timeTracking != null && this.props.timeTracking.endTimestamp != null ?
                new Date(Date.UTC(
                    this.props.date.substr(0, 4),
                    parseInt(this.props.date.substr(5, 2)) - 1,
                    parseInt(this.props.date.substr(8, 2)),
                    parseInt(this.props.timeTracking.endTimestamp.substr(11, 2)),
                    parseInt(this.props.timeTracking.endTimestamp.substr(14, 2)),
                    0
                )).toISOString().substr(0, 23) : 0,
            timeDiff: this.props.timeTracking != null ? this.props.timeTracking.timeDiff : 0
        };

    }

    componentDidMount = () => {
        this.props.log('TimeInput.js/componentDidMount');
        this.setState((prevState) => {
            const timeDiff = Date.parse(prevState.endTimestamp) - Date.parse(prevState.beginTimestamp);
            return { timeDiff: !isNaN(timeDiff) ? timeDiff : 0 }
        })
    }

    msToTime = (s) => {
        this.props.info('TimeInput.js/msToTime (s)', s);
        if (this.state.endTimestamp === 0 && this.state.beginTimestamp === 0) return "No Entry";
        if (this.state.endTimestamp === 0 && this.state.beginTimestamp !== 0) return "In Progress";
        if (s < 0 || s >= (60 * 60 * 24 * 1000) || this.state.beginTimestamp === 0) return "Error";
        var ms = s % 1000;
        s = (s - ms) / 1000;
        var secs = s % 60;
        s = (s - secs) / 60;
        var mins = s % 60;
        var hrs = (s - mins) / 60;
        mins = mins < 10 ? '0' + mins : mins;
        secs = secs < 10 ? '0' + secs : secs;
        return (hrs > 0 ? parseInt(hrs) + ' hr ' : '') + parseInt(mins) + ' min';// + '.' + ms;
    }

    onChange = (e) => {
        this.props.log('TimeInput.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        if (e.target.value == null || e.target.value === '') {
            this.setState(prevState => {
                const sel = prevState;
                sel[e.target.name] = 0 // date;
                sel['timeDiff'] = Date.parse(sel.endTimestamp) - Date.parse(sel.beginTimestamp);
                return sel;
            });
        } else {
            const date = new Date(Date.UTC(
                this.props.date.substr(0, 4),
                parseInt(this.props.date.substr(5, 2)) - 1,
                parseInt(this.props.date.substr(8, 2)),
                0 + parseInt(e.target.value.substr(0, 2)),
                0 + parseInt(e.target.value.substr(3, 2)),
                0
            )).toISOString().substr(0, 23);
            this.setState(prevState => {
                const sel = prevState;
                sel['didChange'] = true;
                sel[e.target.name] = date;
                sel['timeDiff'] = !isNaN(Date.parse(sel.endTimestamp) - Date.parse(sel.beginTimestamp)) ? Date.parse(sel.endTimestamp) - Date.parse(sel.beginTimestamp) : 0;
                return sel;
            });
        }
    }

    utcToLocal = (utc) => {
        this.props.info('TimeInput.js/utcToLocal (utc)', utc);
        var t = new Date((utc));
        var offset = t.getTimezoneOffset() * 60000;
        t.setTime(t.getTime() - offset);
        var d = [t.getFullYear(), t.getMonth(), t.getDate()].join('/');
        d += ' ' + t.toLocaleTimeString();
        return (new Date((Date.parse(d) - offset)).toISOString().substr(0, 23));
    }

    handleTimeTracking = () => {
        this.props.log('TimeInput.js/handleTimeTracking');
        this.props.handleTimeTrackingInput({
            id: this.props.reportId,
            timeTracking: {
                id: this.props.timeTracking != null ? this.props.timeTracking.id : null,
                beginTimestamp: this.state.beginTimestamp !== 0 ? this.utcToLocal(this.state.beginTimestamp) : null,
                endTimestamp: this.state.endTimestamp !== 0 ? this.utcToLocal(this.state.endTimestamp) : null
            }
        });
    }

    render() {
        this.props.info('TimeInput.js/render');
        return (<>
            {this.props.active ? <>
                <Row>
                    <Col md={3} className="timer timerTitle pt-2 px-0">Start</Col>
                    <Col md={9} className="px-0"><Input
                        type="time"
                        name="beginTimestamp"
                        onChange={(e) => this.onChange(e)}
                        value={this.props.isFieldNull(String(this.state.beginTimestamp).substring(11, 5))}
                    /></Col>
                </Row>
                <Row>
                    <Col md={3} className="timer timerTitle pt-2 px-0">End</Col>
                    <Col md={9} className="px-0"><Input
                        type="time"
                        name="endTimestamp"
                        onChange={(e) => this.onChange(e)}
                        value={this.props.isFieldNull(String(this.state.endTimestamp).substring(11, 5))}
                    /></Col>
                </Row>
                <Row>
                    <Col md={3} className="timer timerTitle pt-2 px-0"></Col>
                    <Col md={5} className="px-0 pt-2 timer text-center">
                        {this.msToTime(this.state.timeDiff)}
                    </Col>
                    <Col md={4} className="p-0 text-right">
                        <Button onClick={() => this.handleTimeTracking()} color="success"
                            disabled={
                                ((this.state.timeDiff < 0 ||
                                    this.state.timeDiff >= (60 * 60 * 24 * 1000) ||
                                    !this.state.didChange) &&
                                    (this.state.endTimestamp !== 0 || !this.state.didChange)) || this.state.beginTimestamp === 0
                            }><FontAwesomeIcon icon={faCheck} /></Button>
                    </Col>
                </Row></> :
                <div className="text-center">{this.msToTime(this.state.timeDiff)}</div>}
        </>
        );
    }
}

export default TimeInput;

